import React from "react";
import { useNavigate } from "react-router-dom";
import CustomDatatable from "../CustomDatatable/CustomDatatable";
import type { ColumnMeta } from "../CustomDatatable/CustomDatatable";
import { useUserInstanceRolesAPI } from "../../hooks/api/use-accessAPI";
import { RoleAssignment } from "../../store/types";
import { BodyText } from "../../styles/Typography";
import { formatDateTime, instancePath } from "./accessOptions";
import { SectionText } from "./Access.styles";

/** Глобальные роли пользователя на всех инстансах. Назначение и снятие — на странице инстанса. */
const UserInstanceRolesSection: React.FC<{ userId: string }> = ({ userId }) => {
  const navigate = useNavigate();
  const { assignments } = useUserInstanceRolesAPI(userId);

  const open = (assignment: RoleAssignment) => navigate(instancePath(assignment.instanceId));

  const columns: ColumnMeta<RoleAssignment>[] = [
    { field: "instanceId", header: "Инстанс", sortable: true, body: (x) => <code>{x.instanceId}</code> },
    { field: "organizationName", header: "Компания", sortable: true },
    { field: "roleName", header: "Роль", sortable: true, body: (x) => <code>{x.roleName}</code> },
    { field: "grantedAt", header: "Назначена", sortable: true, body: (x) => formatDateTime(x.grantedAt) },
  ];

  return (
    <>
      <SectionText>
        <BodyText>
          Глобальные роли на инстансах продуктов. Назначить или снять роль можно на странице
          инстанса.
        </BodyText>
      </SectionText>
      <CustomDatatable<RoleAssignment>
        data={assignments}
        columns={columns}
        onView={open}
        onRowDoubleClick={open}
        getRowId={(x) => x.id}
        hideViewButton={false}
        hideEditButton
        hideDeleteButton
        hideContextMenu
        sortable
      />
    </>
  );
};

export default UserInstanceRolesSection;
